   <dn-progress-spinner *ngIf="showSpinner"></dn-progress-spinner>
<div class="col-lg-11 col-md-11 col-sm-12 shadow-lg rounded mt-5 ms-md-5 mb-5">
		<div class="d-flex p-4" *ngIf="!registered">
			<div ngbNav #navc="ngbNav" [(activeId)]="active" class="nav-pills flex-column col-auto"
				orientation="vertical">
				<div class="row text-primary">
					<h5 class="mt-2 d-flex justify-content-center ">
						<i class="fa-regular fa-user fa-2xl"></i><br>
					</h5>
					<h5 class="d-flex justify-content-center">
						<span>Register</span>
					</h5>
				</div>
				<ng-container [ngbNavItem]="step.stage.toString()" *ngFor="let step of steps" [disabled]="!unlockedStage(step.stage)">
					<button ngbNavLink>
						<i class="mt-1 ms-2 fa-solid" [ngClass]="{'fa-lock': !unlockedStage(step.stage), 'fa-lock-open': unlockedStage(step.stage) && !hasStepCompleted(step.stage), 'fa-check': hasStepCompleted(step.stage)}" style="float: left;" ></i>
						<span class="d-none d-sm-inline ms-3" style="float: inline-start;">{{step.navText}}</span>
					</button>

					<ng-template ngbNavContent *ngIf="step.stage==Stage.TOU">
						<terms-of-use [touContent]="'tou.content' | translate"
								[touCheckBoxName]="'tou.checkBoxName' | translate"
								(touAcceptedEvent)="hasStepResponse($event,step.stage)">
						</terms-of-use>
					</ng-template>

					<ng-template ngbNavContent *ngIf="step.stage==Stage.USER_CREATION">
							<registration-form (onRegister)="hasStepResponse($event,step.stage)"
												(onRegisterEmail)="hasStepResponse($event,step.stage)"
												(onRegistrationRestart)="restartJourney()"
										buttonText="{{'registration.button-text' | translate}}"
										[autofocus]="focusemail">
							</registration-form>
					</ng-template>

					<ng-template ngbNavContent *ngIf="step.stage == Stage.OTP">
						<form id="clientVerificationForm" name="clientVerificationForm" #clientVerificationForm="ngForm"
      					(ngSubmit)="onVerificationSubmit(clientVerificationForm)" novalidate dnErrorControl="errorControl" #errorControl="dnErrorControl">
							<dn-confirmation #dnConfirm></dn-confirmation>
							<div class="col-md-8">
								<otp-choices [stage]="nextStage" (OnOtpMethodSelected)="setOtpChoice(clientVerificationForm,$event,Stage.OTP_METHOD)" *ngIf="nextStage == Stage.OTP_METHOD"></otp-choices>

								<input-otp name="onetimePassword" *ngIf="nextStage == Stage.OTP || nextStage == Stage.OTP_RESEND"
									[disabled]="resending"
									otpInstruction="otp.instruction"
									[otpMethod]="otpChoice.otpMethod"
									[otpMaskedValue]="otpChoice.otpMaskedValue"
									(OnResendCode)="handleResendCode($event)"
									[stage]="nextStage"
									[autofocus]="nextStage == Stage.OTP || nextStage == Stage.OTP_RESEND">
								</input-otp>
							</div>
							<div class="mt-4 d-flex justify-content-center" *ngIf="step.stage == Stage.OTP && !verificationComplete">
								<button type="submit" class="btn btn-primary"  #otpSubButton
									[disabled]="!clientVerificationForm.form.valid || otpSubmitted || resending">Submit <i class="fa-solid fa-spinner" *ngIf="otpSubmitted"></i></button>
							</div>
						</form>
					</ng-template>
				</ng-container>


			</div>
			<div class="d-flex ms-4 text-primary">
				<div class="vr"></div>
			</div>
			<div [ngbNavOutlet]="navc" class="mt-3 ms-4 col-md-8 pt-5"></div>

			<!-- End Nav -->

		</div>
		<div class=" rounded p-1 text-muted smaller-font" *ngIf="!registered" >
			<p style="text-align: center;">
				<span [innerHTML]="'registration.reg-contact-info'| translate:{phone: ('support.phone'|translate),support_site: ('support.site'|translate)}"></span></p>
			   
		</div>
</div>
